import { usePreloadedQuery } from 'react-relay';
import { ReportSubtype } from '../models/Report';
import { ReportHubDiagnosticAssessmentTotalQuery } from '../graphQLOperations/__generated__/ReportHubDiagnosticAssessmentTotalQuery.graphql';
import { ReportHubSkillAssessmentsTotalQuery } from '../graphQLOperations/__generated__/ReportHubSkillAssessmentsTotalQuery.graphql';
import { ReportHubOutstandingAssessmentsTotalQuery } from '../graphQLOperations/__generated__/ReportHubOutstandingAssessmentsTotalQuery.graphql';
import {
  getTotalDiagnosicAssessmentHistory,
  getTotalOutstandingAssessments,
  getTotalSkillAssessmentHistory,
} from '../graphQLOperations/ReportHub';

import { PreloadedQuery } from 'react-relay';

export const useReportHubPreloadedQuery = (
  subtype: ReportSubtype,
  queryRef:
    | PreloadedQuery<ReportHubDiagnosticAssessmentTotalQuery, Record<string, unknown> | null>
    | PreloadedQuery<ReportHubSkillAssessmentsTotalQuery, Record<string, unknown> | null>
    | PreloadedQuery<ReportHubOutstandingAssessmentsTotalQuery, Record<string, unknown> | null>,
) => {
  if (!queryRef) return null;

  let data;
  switch (subtype) {
    case ReportSubtype.DIAGNOSTIC_SUMMARY:
      data = usePreloadedQuery<ReportHubDiagnosticAssessmentTotalQuery>(
        getTotalDiagnosicAssessmentHistory,
        queryRef as PreloadedQuery<ReportHubDiagnosticAssessmentTotalQuery>,
      );
      return data?.allSkills?.totalCount || 0;
    case ReportSubtype.PROGRESS_SKILL_ASSESSMENT_HISTORY:
      data = usePreloadedQuery<ReportHubSkillAssessmentsTotalQuery>(
        getTotalSkillAssessmentHistory,
        queryRef as PreloadedQuery<ReportHubSkillAssessmentsTotalQuery>,
      );
      return data?.studentsSkillAssessments?.totalCount || 0;
    case ReportSubtype.DIAGNOSTIC_STUDENTS_UNFINISHED_DIAGNOSTIC:
      data = usePreloadedQuery<ReportHubOutstandingAssessmentsTotalQuery>(
        getTotalOutstandingAssessments,
        queryRef as PreloadedQuery<ReportHubOutstandingAssessmentsTotalQuery>,
      );
      return data?.allStudents?.totalCount || 0;
    default:
      return null;
  }
};
